import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const ClientPresence = () => {
    const navigate = useNavigate();
    const { orderId } = useParams();

    const handlePresence = (isHome) => {
        if (isHome) {
            navigate(`/checklist/${orderId}/client-consent`); // Переход к уведомлению
        } else {
            navigate(`/checklist/${orderId}/select-zones`); // Переход к выбору зон
        }
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>Клиент дома?</h1>
            <button style={styles.button} onClick={() => handlePresence(true)}>Да</button>
            <button style={{ ...styles.button, backgroundColor: '#000' }} onClick={() => handlePresence(false)}>Нет</button>
        </div>
    );
};

const styles = {
    container: { textAlign: 'center', padding: '20px', maxWidth: '600px', margin: '0 auto' },
    heading: { fontSize: '28px', fontWeight: 'bold', marginBottom: '30px', color: '#000' },
    button: {
        width: '90%',
        padding: '20px',
        margin: '10px 0',
        fontSize: '22px',
        borderRadius: '8px',
        border: 'none',
        color: 'white',
        backgroundColor: '#6CC8D9',
        cursor: 'pointer',
    }
};

export default ClientPresence;